import { ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import {
    IAttributeConfData,
    ProductConfigurableOptionsComponentDef
} from '@df/catalog-ui/product/configurable-options/product-configurable-options.component.def';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { LocalProduct } from 'projects/app-default/src/app/catalog/model/product/product.decorator';
import { AttributeLabelPipe } from '@df/ui/common/attribute-label.pipe';
import compact from 'lodash-es/compact';
import { IProductStockData, ProductConfigurableOptionsStockService } from './product-configurable-options-stock.service';

export interface IProductOptionStock {
    label: string;
    qty: number;
}
@Component({
    selector: 'product-configurable-options-stock',
    templateUrl: './product-configurable-options-stock.component.html',
    standalone: true,
    imports: [AttributeLabelPipe],
    styleUrls: ['./product-configurable-options-stock.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductConfigurableOptionsStockComponent
    extends ProductConfigurableOptionsComponentDef<LocalProduct<IProductDataV3>>
    implements OnInit
{
    @Output()
    initialized = new EventEmitter<void>();
    stocks: IProductOptionStock[] = [];
    protected productConfigurableOptionsStockService = inject(ProductConfigurableOptionsStockService);
    override ngOnInit(): void {
        super.ngOnInit();
        this.initialized.emit();
        this.productConfigurableOptionsStockService.loaded$.subscribe((stocks: IProductStockData) => {
            if (stocks && Object.keys(stocks)?.length) {
                this.setAttributes(this.getConfigurableMap());
                this.stocks = compact(
                    this.sizeAttribute?.options?.map(option => {
                        const productSku = option.product?.data?.sku;
                        if (productSku) {
                            const tradeStock = stocks[productSku]?.find(i => i.source_code === 'trade');
                            const retailStock = stocks[productSku]?.find(i => i.source_code === 'retail');
                            const qty = (tradeStock?.quantity || 0) + (retailStock?.quantity || 0);
                            return {
                                label: `${option.label}`,
                                qty
                            };
                        }
                    })
                );
                this.detectChanges();
            }
        });
    }
    get sizeAttribute(): IAttributeConfData | undefined {
        return this.attributes?.find(i => i.code === 'size');
    }
}
